module.exports = __webpack_public_path__ + "img/game.0665d7e3.png";